/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	
	'use strict';

	/**
	 * Dynamic Support module
	 * @author Nikola Lakovic
	 * @namespace Tc.Module.DynamicSupport.js
	 * @class DynamicSupport
	 * @extends Tc.Module
	 *
	 **/

	Tc.Module.DynamicSupport = Tc.Module.extend({

		on: function(callback) {

			var mod = this,
				$ctx = this.$ctx,
				$dynamicsupportpar = $ctx.find('.dynamicsupportpar'),
				$dynamicSupportHolder = $ctx.find('.dynamicSupportHolder'),
				$language = $('html').attr('lang'),
				$content = '';

			$.ajax({
				url: '/management/rest/v1/support_information/selected',
				type: 'GET',
				dataType: 'json',
				processData: false,
				contentType: 'application/json; charset=UTF-8',
				success: function (data) {
					mod.tmplItem = doT.template($('#support', $ctx).html());
					$.each(data, function(index, value) {
						if(index === $language) {
							$content = $(mod.tmplItem(data[$language]));
							return false;
						} else {
							$content = $(mod.tmplItem(data['en']));
						}
					});
					
					$dynamicSupportHolder.append($content);
					if($dynamicSupportHolder.children().length > 1) {
						$dynamicsupportpar.hide();
					} 
				},
				error: function () {
					debug.log("Tc.Module.DynamicSupport.js module > Ajax call went wrong");
				}
			});

			callback();
		}
	});

})(Tc.$);
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.DynamicSupport.js
// module id = 137
// module chunks = 0